import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useEffect, useState } from "react";
const sentiments = ["Positive","Neutral","Negative" ];

const BarChartCompetitorReview = ({ data, selectedCategories,onChangeTab}) => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  
  const selectedOrder = data?.selectedCompanies || [];
  const companies = data?.companies || [];
  const orderedCompanies = selectedOrder.length
  ? selectedOrder.map((name) => companies.find((c) => c.name === name)).filter(Boolean)
  : companies;
  const categories = orderedCompanies.map((company) => company.name);
  const graphData = Array.from(sentiments).map((key) => ({
    dataLabels: {
      enabled: true,
      inside: true,  
      verticalAlign: "middle",
      format: "{point.y:.0f}%",  
      style: {
        fontSize: "12px",
        fontWeight: 500,
        fontFamily: "Verdana, sans-serif",     
        textOutline: 'none'    
      },
    },
    
    // maxPointWidth: 30,
    groupPadding: 0.09,
    pointPadding: 0,
    borderWidth: 0,
    shadow: false,
    name: key,
    data: orderedCompanies.map((company) => {
      const category = company[selectedCategories];
      return category?.[key?.toLowerCase()] ?? 0;
    }),
  }));

  const getOptions = {
    chart: {
      type: 'bar',
    marginLeft: 0,
    marginRight: 0,
    spacingLeft: 0,
    spacingRight: 0,
      
      type: "column",
      animationLimit: 1000,
      // scrollablePlotArea: {
      //   minHeight:
      //     categories?.length < 8 ? 350 : categories?.length < 16 ? 800 : 2000,
      //   opacity: 1,
      //   scrollPositionY: 0,
      // },
    },
    title: {
      text: "",
      align: "left",
      useHTML: true,
      style: {
        fontSize: "13px",
      },
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: false,
      layout: "horizontal",
      // layout: "vertical",
    },
    tooltip: {
      shared: false,
      useHTML: true,
      formatter: function () {
        const companyIndex = this.point.x;
        const company = orderedCompanies[companyIndex];
        const category = company[selectedCategories];
        const reviewCount = category?.total || 0;
    
        return `<b>${company.name}</b><br/>
        <span style="color:${this.point.color}; line-height: 20px;">\u25CF</span> 
        ${this.series.name}: ${this.point.y}%<br/>
        <b>Total Reviews:</b> ${reviewCount}`;
},
      outside: false,
      followPointer: true,
    },
    
    
    
    loading: {
      hideDuration: 1000,
      showDuration: 1000,
    },
    plotOptions: {
      column: {
        stacking: "percent",
        maxPointWidth: 80,
        states: {
          hover: {
            enabled: false 
          }
        },
      
        dataLabels: {
          enabled: true,
          format: "{point.percentage:.0f}%"
        }
      },
      series: {
        cursor: "pointer",
        states: {
          inactive: {
            opacity: 1
          }
        },
        point: {
          events: {
            click: function () {
              if (onChangeTab) {
                const sentiment = this.series.name === "Neutral" ? null : this.series.name.toLowerCase();
    onChangeTab("detailed-insights", this.category, sentiment);
              }
            }
            
          }
        },
        
      },
      scatter: {
        states: {
          inactive: {
            opacity: 1 
          }
        }
      },
    },
     
    series: graphData,
    credits: {
      enabled: false,
    },    
    // colors: ["#431772", "#642AA3", "#964EE3"],
    // colors: ["#66bb6a", "#ed5651", "#f16521"],
    
    // colors: ["#f16521", "#ed5651", "#66bb6a",],

    colors: ["#04BFC4","#EAEBEB","#F8766D"],


    // colors: ["#f16521", "#FF0000", "#66bb6a",],
    // colors: ["orange", "red", "#66bb6a",],
    xAxis: {
      type: "category",
      categories: categories,
      gridLineWidth: 0,
      lineWidth:0,
      labels: {
        enabled: true,
        // align: "left",
        // reserveSpace: true,
        rotation: isMobile ? 270 : 0,
        style: {
          color: "#707070",
          fontSize: "14px",
          fontFamily: "Poppins",
          textTransform: "capitalize",
        },
      },
      lineColor: "#707070",
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        enabled: false,
        format: "{value}%",
      },
      gridLineWidth: 0,
      min: 0,
      max: 110, 
      endOnTick: false, 
      startOnTick: false,  
      tickInterval: 20,      
      lineColor: "#707070",
      lineWidth: 0,
      showFirstLabel: true,  
      showLastLabel: true, 
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={getOptions} />
    </div>
  );
};

export default BarChartCompetitorReview;
